import { node } from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';

const useStyles = makeStyles((theme) => ({
    root: {
        zIndex: 20000,
        pointerEvents: 'auto',
        position: 'relative',
        '& .MuiSnackbarContent-message': {
            flexGrow: 1,

            '& span': {
                justifyContent: 'center',
            },
        },
    },
    containerRoot: {
        zIndex: 20000,
        display: 'grid',
        justifyItems: 'stretch',
        pointerEvents: 'auto',
    },
    contentRoot: {
        ...(theme.palette.type === 'dark'
            ? {
                  backgroundColor: theme.palette.panel.main,
                  color: theme.palette.panel.contrastText,
              }
            : {}),
    },
}));

export default function AppSnackbarProvider({ children }) {
    const classes = useStyles();
    return (
        <SnackbarProvider maxSnack={4} anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }} classes={classes}>
            {children}
        </SnackbarProvider>
    );
}

AppSnackbarProvider.propTypes = {
    children: node,
};

AppSnackbarProvider.defaultProps = {
    children: null,
};
